import { Component } from "react";

import "./style.scss";
class Alignment extends Component {

    state = {
        align:1
    }

    setAlign=(value)=>{
        this.setState({align:value})
        this.props.onAlignChange(value);
    }

    render() {
        return (
            <>
                <div className="alignment">
                    <div className="label">Alignment</div>
                    <div className="options">
                        <div className={`left ${!this.state.align ? "active" : ""}`} onClick={()=>this.setAlign(0)}><span></span><span></span><span></span></div>
                        <div className={`center ${this.state.align===1 ? "active" : ""}`} onClick={()=>this.setAlign(1)}><span></span><span></span><span></span></div>
                        <div className={`right ${this.state.align===2 ? "active" : ""}`} onClick={()=>this.setAlign(2)}><span></span><span></span><span></span></div>
                    </div>
                </div>
            </>
        )
    }
}

export default Alignment;